export class PasswordChangeCommand {
  username: string;
  currentPassword: string;
  newPassword: string;
}